import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/store/useAuth';
import { resendVerification } from '@/services/authClient';
import { Button } from '@/components/ui/button';

export function EmailVerifyBanner() {
  const isAuthenticated = useAuth((s) => s.isAuthenticated);
  const isEmailVerified = useAuth((s) => s.isEmailVerified);
  const user = useAuth((s) => s.user);
  const [sending, setSending] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!isAuthenticated || isEmailVerified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await resendVerification(user?.email);
      toast.success('Verification email sent. Check your inbox.');
    } catch {
      toast.error('Could not resend verification email. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-2.5" role="status" data-testid="email-verify-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2">
        <p className="text-sm text-amber-900">
          Please verify your email to secure your account.
          {' '}
          <Link to="/help" className="font-medium underline hover:text-amber-700">Need help?</Link>
        </p>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="h-8 rounded-lg border-amber-300 bg-white text-amber-900 hover:bg-amber-100"
            disabled={sending}
            onClick={handleResend}
          >
            {sending ? 'Sending…' : 'Resend email'}
          </Button>
          <button
            type="button"
            className="text-xs font-medium text-amber-800/70 hover:text-amber-900"
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
